import { render, staticRenderFns } from "./PromoCarousel.vue?vue&type=template&id=07a944a2&scoped=true"
import script from "./PromoCarousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./PromoCarousel.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PromoCarousel.vue?vue&type=style&index=0&id=07a944a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a944a2",
  null
  
)

export default component.exports